import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { Box, HStack } from "@chakra-ui/react";
import "../App.css";

const socials = [
  {
    icon: faEnvelope,
    url: "mailto: ezmarie97@gmail.com",
  },
  {
    icon: faGithub,
    url: "https://github.com/Ezz1997",
  },
  {
    icon: faLinkedin,
    url: "https://www.linkedin.com/in/ezz-maree-9177b926b/",
  },
];

const Header = () => {
  const headerRef = useRef(null);

  useEffect(() => {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const headerElement = headerRef.current;
      if (!headerElement) {
        return;
      }
      if (prevScrollPos > currentScrollPos) {
        headerElement.style.transform = "translateY(0)";
      } else {
        headerElement.style.transform = "translateY(-200px)";
      }
      prevScrollPos = currentScrollPos;
    }
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, []);

  const handleClick = (anchor) => () => {
    const id = `${anchor}-section`;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      translateY={0}
      transitionProperty="transform"
      transitionDuration=".3s"
      transitionTimingFunction="ease-in-out"
      backgroundColor="#18181b"
      ref={headerRef}
      zIndex="1"
    >
      <Box color="white" maxWidth="1280px" margin="0 auto">
        <HStack
          px={[6, 16]}
          py={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <nav>
            <HStack spacing={4}>
              {socials.map(({ icon, url }, index) => {
                return (
                  <a href={url} target="_blank" key={url} rel="noopener noreferrer"  data-testid={`social-link-${index}`}>
                    <FontAwesomeIcon icon={icon} size="2x" className="social-icon" key={url}/>
                  </a>
                );
              })}
            </HStack>
          </nav>
          <nav>
            <HStack spacing={4} >
              <a href="#projects" onClick={handleClick('projects')} data-testid="projects-section" className="inline-link">Projects</a>
              <a href="#contactme" onClick={handleClick('contactme')} className="inline-link">Contact Me</a>
            </HStack>
          </nav>
        </HStack>
      </Box>
    </Box>
  );
};
export default Header;
